import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["city", "cityLabel"]

  chooseCity(event) {
    const { slug, name } = event.currentTarget.dataset

    if (this.hasCityTarget) {
      this.cityTarget.value = slug
    }

    if (this.hasCityLabelTarget) {
      this.cityLabelTarget.textContent = name
    }
  }
}
